import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const TeamSection = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  // 🔁 載入語言檔（每次語系變動就會重新載入）
  useEffect(() => {
    loadLanguageFile("Team", "team/team_body_lang");
  }, [language]);

  // ✅ 安全讀取語言內容
  const LANGUAGE = componentLanguageData.Team || { Main: {}, Experience: {}, Expertise: {} };

  // ✅ 成員資料定義：放在 render 裡面才拿得到最新語系
  const teamMembers = [
    {
      name: LANGUAGE.Main.Content2,
      name_1: LANGUAGE.Main.Content2_1,
      experience_title: LANGUAGE.Experience.Title,
      expertise_title: LANGUAGE.Expertise.Title,
      experience_content1: LANGUAGE.Experience.Sam1,
      expertise_content1: LANGUAGE.Expertise.Sam1,
      expertise_content2: LANGUAGE.Expertise.Sam2,
      expertise_content3: LANGUAGE.Expertise.Sam3,
      img: '/img/CEO.png',
      delay: '0.6s',
    },
    {
      name: LANGUAGE.Main.Content1,
      name_1: LANGUAGE.Main.Content1_1,
      experience_title: LANGUAGE.Experience.Title,
      expertise_title: LANGUAGE.Expertise.Title,
      experience_content1: LANGUAGE.Experience.Sean1,
      expertise_content1: LANGUAGE.Expertise.Sean1,
      expertise_content2: LANGUAGE.Expertise.Sean2,
      expertise_content3: LANGUAGE.Expertise.Sean3,
      img: '/img/CTO.png',
      delay: '0.3s',
    },
    {
      name: LANGUAGE.Main.Content6,
      name_1: LANGUAGE.Main.Content6_1,
      experience_title: LANGUAGE.Experience.Title,
      expertise_title: LANGUAGE.Expertise.Title,
      experience_content1: LANGUAGE.Experience.Jessica1,
      expertise_content1: LANGUAGE.Expertise.Jessica1,
      expertise_content2: LANGUAGE.Expertise.Jessica2,
      expertise_content3: LANGUAGE.Expertise.Jessica3,
      img: '/img/STE.png',
      delay: '0.9s',
    },
    {
      name: LANGUAGE.Main.Content3,
      name_1: LANGUAGE.Main.Content3_1,
      experience_title: LANGUAGE.Experience.Title,
      expertise_title: LANGUAGE.Expertise.Title,
      experience_content1: LANGUAGE.Experience.Sans1,
      expertise_content1: LANGUAGE.Expertise.Sans1,
      expertise_content2: LANGUAGE.Expertise.Sans2,
      expertise_content3: LANGUAGE.Expertise.Sans3,
      img: '/img/CMO.png',
      delay: '0.9s',
    },
    {
      name: LANGUAGE.Main.Content7,
      name_1: LANGUAGE.Main.Content7_1,
      experience_title: LANGUAGE.Experience.Title,
      expertise_title: LANGUAGE.Expertise.Title,
      experience_content1: LANGUAGE.Experience.Tianji1,
      expertise_content1: LANGUAGE.Expertise.Tianji1,
      expertise_content2: LANGUAGE.Expertise.Tianji2,
      expertise_content3: LANGUAGE.Expertise.Tianji3,
      img: '/img/NSSA.png',
      delay: '0.9s',
    },
  ];

  return (
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: '680px' }}>
          <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content4}</h5>
          <h1 className="mb-0">{LANGUAGE.Main.Content5}</h1>
        </div>
        <div className="row g-5">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="col-lg-4 wow slideInUp"
              data-wow-delay={member.delay}
            >
              <div className="team-item bg-light rounded overflow-hidden">
                <div className="team-img position-relative overflow-hidden" style={{ padding: '5%' }}>
                  <img className="img-fluid w-100" src={member.img} alt={member.name} />
                </div>
                <div className="text-center py-4">
                  <h4 className="text-primary">{member.name}</h4>
                  <h4 className="text-primary">{member.name_1}</h4>
                  <p className="text-uppercase m-0" style={{ fontSize: "1.2em", fontWeight: "bold", color: "#a70002" }}>
                    {member.experience_title}
                  </p>
                  <p style={{ padding: "0 5%" }}>{member.experience_content1}</p>
                  <p className="text-uppercase m-0" style={{ fontSize: "1.2em", fontWeight: "bold", color: "#a70002" }}>
                    {member.expertise_title}
                  </p>
                  <p>{member.expertise_content1}<br />{member.expertise_content2}<br />{member.expertise_content3}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamSection;
